import React from 'react';
import styled from 'styled-components';

import Radio from '../radio';
import spacer from '../spacer';

const InlineRadio = ({
  className,
  placeholder,
  onChange,
  name,
  ...props
}) => (
  <div className={className}>
    {placeholder && (
      <Placeholder>{placeholder}</Placeholder>
    )}
    {props.options.map((option) => (
      // eslint-disable-next-line jsx-a11y/label-has-associated-control
      <label key={option} css="cursor: pointer;">
        <Radio
          onChange={onChange}
          name={name}
          type="radio"
          value={option}
          css="margin-left: .5rem;"
        />
        {option}
      </label>
    ))}
  </div>
);

const Placeholder = styled.span`

`;

export default styled(InlineRadio)`
  ${({ $noSpacer }) => !$noSpacer && spacer}
`;
